import { elementIsVisibleInViewport } from '@src/js/utils/global-functions';

export default class InPageNavigation {
  constructor(context) {
    this.element = {
      container: context,
      scrollThreshold: parseInt(context.querySelector('[data-scroll-threshold]')?.getAttribute('data-scroll-threshold')) || 0,
      links: [...context.querySelectorAll('.page-navigation__link')],
    };
    this.isPLP = location.href.includes('/collections/');

    if (this.isPLP) this.checkForOtherModules();
    this.observeModules();
    this.showNav();
    this.initScrollListener();
    this.initNavListeners();
    this.observeNav();
  }

  // Harcode the threshold if specific modules are present on PLP's
  checkForOtherModules() {
    const hero = document.querySelector('.section-secondary-hero');
    const storyMedia = hero.querySelector('.story__media');
    const heroImage = hero.querySelector('.secondary-hero__image');
    const educationTiles = document.querySelector('.module--education-tiles');

    if (storyMedia || heroImage || educationTiles) {
      this.element.scrollThreshold = 750;
    }
  }

  observeModules() {
    const { links } = this.element;
    links.forEach((link) => {
      const moduleId = link.getAttribute('href');
      // Site Ops uses mutiple modules with the same ID, so we accomodate that.
      const els = document.querySelectorAll(moduleId);

      /*
       * Of note here is the top and bottom root margins that theoretically
       * "touch" each other. Prevents multiple links from having active state
       * at the same time.
       */
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            link.classList.toggle('button--active', entry.isIntersecting);
          });
        },
        { rootMargin: '-70% 0px -30% 0px' }
      );

      els.forEach((el) => observer.observe(el));
    });
  }

  initNavListeners() {
    const { links } = this.element;

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const moduleId = link.getAttribute('href');
        e.preventDefault();
        window.scrollTo(0, document.querySelector(moduleId).getBoundingClientRect().top + window.scrollY - 171);
      });
    });
  }

  initScrollListener() {
    window.addEventListener('scroll', (e) => {
      this.showNav();
    });
  }

  showNav() {
    const { scrollThreshold } = this.element;
    window.scrollY >= scrollThreshold ? this.toggleNav(true) : this.toggleNav(false);
  }

  toggleNav(active) {
    const { container } = this.element;
    if (active && !container.classList.contains('active')) {
      container.classList.add('active');
    } else if (!active && container.classList.contains('active')) {
      container.classList.remove('active');
    }
  }

  /*
   * We observe the nav to determine whether the sticky positioned element has
   * been stuck to the top of the page. Since in-page-nav appears to stick
   * beneath the nav, I've added some fiddly rootMargin to account for this.
   * For the .is-stuck class to be applied, the top value of the rootMargin must
   * be one px more than the px value set in .section-in-page-navigation's top
   * CSS attribute.
   *
   * Based on the following, with my own root margin and top added:
   * https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
   *
   */
  observeNav() {
    const el = this.element.container;
    const observer = new IntersectionObserver(([e]) => e.target.classList.toggle('is-stuck', e.intersectionRatio < 1), { threshold: [1], rootMargin: '-91px 0px 0px 0px' });

    observer.observe(el);
  }
}
